<template>
  <div
    class="pointer-events-auto w-full max-w-md cursor-pointer rounded-lg border-2 border-black-dark bg-white transition-all duration-300 dark:bg-kekkle-dark-light"
    :class="[shadowClass, 'animate-slide-in']"
    @click="handleClick"
  >
    <div class="flex items-center gap-3 p-4">
      <!-- Emoji -->
      <div v-if="emoji" class="shrink-0 text-2xl">
        {{ emoji }}
      </div>

      <!-- Content -->
      <div class="flex-1 overflow-hidden">
        <!-- Title -->
        <h3
          v-if="title"
          class="mb-1 font-semibold text-gray-900 dark:text-white"
        >
          {{ title }}
        </h3>

        <!-- Message -->
        <p class="text-sm text-gray-700 dark:text-gray-300">
          {{ message }}
        </p>
      </div>

      <!-- Close button -->
      <button
        class="shrink-0 rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-kekkle-dark dark:hover:text-gray-300"
        @click.stop="$emit('close')"
      >
        <svg
          class="h-5 w-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ToastType } from "@/types/toast";

type Props = {
  type: ToastType;
  message: string;
  title?: string;
  emoji?: string;
  onClick?: () => void;
};

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const shadowClass = computed(() => {
  switch (props.type) {
    case "success":
      return "shadow-green-hard";
    case "info":
      return "shadow-blue-hard";
    case "warning":
      return "shadow-yellow-hard";
    case "error":
      return "shadow-red-hard";
    default:
      return "shadow-yellow-hard";
  }
});

function handleClick() {
  if (props.onClick) {
    props.onClick();
  }
}
</script>

<style scoped>
@keyframes slide-in {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-slide-in {
  animation: slide-in 0.3s ease-out;
}
</style>
